export default __webpack_public_path__ + "static/media/link.464a177e.svg";